// VerticalSeparatorControlView.js

import { View } from 'backbone';
import eventBus         from 'EventBus.js';

import BaseControlView from 'BaseControlView.js';
import template from 'advanced-visuals/control-vertical-separator.ejs';
import themeService     from 'ThemeService.js';

//=====================================================================
//
// An instance of this view represents a vertical separator control
//
// Lou Mauget, November 8, 2015
//
//=====================================================================
class VerticalSeparatorControlView extends BaseControlView  {

        initialize( opts ) {

            super.initialize( opts );
            this.template = template;
            this.tagName = 'div';
            this.model.set('width', themeService.resolve('~seperatorSize'), {silent: true} );
            this.events = {
            };

            this.listenTo(this.model, 'change', this.render);
            this.listenTo( eventBus, 'SeparatorThemeChange', this.themeChangeRender);

            return this;
        }

        // Neighbor aligner uses this polymorphic property, looking for
        // value 'BaseStaticTextControl'
        get kind() {
            return 'VerticalSeparatorControlView';
        }


}

export default VerticalSeparatorControlView;

